import React, { useRef } from 'react';
var VeltNotificationsToolIcon = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-tool-icon", { ref: ref }, children));
};
export default VeltNotificationsToolIcon;
